import { APP_V2_APP_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { Button } from "@src/appV2/redesign/components/Button";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useHistory } from "react-router-dom";

import { getPlacementsRootPath } from "../paths";
import { type PlacementData } from "../types/placement";

interface BrowseMyJobsButtonProps {
  applicationMethod: PlacementData["applicationMethod"];
  buttonText: string;
  logMetadata: {
    workplaceId: string;
    placementId: string;
    buttonSource: "placement_details_page";
  };
}

export function BrowseMyJobsButton(props: BrowseMyJobsButtonProps) {
  const { applicationMethod, buttonText, logMetadata } = props;
  const { workplaceId, placementId, buttonSource } = logMetadata;
  const history = useHistory();
  const { userId: workerId } = useDefinedWorker();

  const path =
    applicationMethod === "instant_interview"
      ? getPlacementsRootPath({
          showApplications: true,
          interviews: true,
        })
      : getPlacementsRootPath({
          showApplications: true,
          applications: true,
        });

  return (
    <Button
      fullWidth
      variant="outlined"
      size="large"
      onClick={async () => {
        logEvent(APP_V2_APP_EVENTS.PLACEMENT_DETAILS_PAGE_ACTIONS, {
          action: "browse_my_jobs_button_clicked",
          placementId,
          applicationMethod,
          source: buttonSource,
          workerId,
          workplaceId,
        });
        history.replace(path);
      }}
    >
      {buttonText}
    </Button>
  );
}
